import ConstructedResponseAnswerApi from './ConstructedResponseAnswerApi';
export default ConstructedResponseAnswerApi;
